<template>
    <div id="transferReceiptModal" ref="transferReceiptModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title select">Transfer Receipt: {{ receipt._id }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body" id="receipt_container">
            <vue3-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="false"
              :preview-modal="true"
              :manual-pagination="false"
              :paginate-elements-by-height="1400"
              :filename="`TranferOrder-${receipt._id}.pdf`"
              :pdf-quality="2"
              pdf-format="A4"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              :html-to-pdf-options="options"
              html
              ref="receipt_body"
            >
              <template v-slot:pdf-content>
                <div class="container rtl" id="receipt_body">
                  <div class="row">
                    <div class="col text-center">
                      <img class="w-50" draggable="false" src='@/assets/logo.png'>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="my-1">
                      <p class="text-center fw-bold">اذن صرف واستلام بضاعة</p>
                      <hr class="my-1">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-end m-0">التاريخ</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0">{{ receipt.date }}</p>
                    </div>
                    <div class="col-2 py-0">
                      <p class="text-end m-0">من مخزن</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0">{{ receipt.src_branch }}</p>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-end m-0">العميل</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0"> ..................................... </p>
                    </div>
                    <div class="col-2 py-0">
                      <p class="text-end m-0">الجهة</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0">{{ receipt.dst_branch }}</p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-end m-0">مندوب التسليم</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0">{{ receipt.driver }}</p>
                    </div>
                    <div class="col-2 py-0">
                      <p class="text-end m-0">رقم السيارة:</p>
                    </div>
                    <div class="col-4 py-0">
                      <p class="text-end m-0">{{ receipt.truck }}</p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 py-0">
                      <p class="text-end m-0">تحصيل</p>
                    </div>
                    <div class="col-10 py-0">
                      <p class="text-end m-0"></p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-center">
                      <hr class="py-1">
                      <table class="table table-sm align-middle border-dark" style="">
                        <thead>
                          <tr class="table-secondary">
                            <th class="text-center w-10">العدد</th>
                            <th class="text-center w-60">الصنف</th>
                            <th class="text-center w-10">كود</th>
                            <th class="text-center w-20">ملاحظات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="x, i in receipt.items" :key="i" class="">
                            <td class="text-center w-10">{{ x.quantity }}</td>
                            <td class="text-center w-60">{{ x.name }}</td>
                            <td class="text-center w-10"></td>
                            <td class="text-start w-20"></td>
                          </tr>

                          <tr>
                            <td colspan="4">
                            </td>
                          </tr>

                          <tr class="table-secondary fw-bold">
                            <td class="text-center w-10">{{ total }}</td>
                            <td class="text-center w-60"></td>
                            <td class="text-center w-10"></td>
                            <td class="text-start w-20"></td>
                          </tr>
                        </tbody>
                      </table>
                      <hr class="py-1">
                    </div>
                  </div>


                  <div class="row mb-1">
                    <div class="col py-0">
                      <p class="text-end m-0">استلمت انا / {{ receipt.driver }}</p>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col py-0">
                      <p class="text-end m-0">البضاعة الموضعة اعلاه و تم معاينتها عدد و مقاس و نوع و اصبحت امانة في عهدتي و على مسئولتي ولا تبرء ذمتي من هذا الايصال ايلا بعد تسليمها للعميل بدون اي تلف او عجز و التوقيع عللى هذا الايصال بالاستلام</p>
                    </div>
                  </div>


                  <div class="row mb-2">
                    <div class="col py-0">
                      <p class="text-end m-0">الاسم /</p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col py-0">
                      <p class="text-end m-0">التوقيع /</p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col py-0">
                      <p class="text-end m-0">الرقم القومي /</p>
                    </div>
                  </div>

                </div>
              </template>
            </vue3-html2pdf>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <button class="btn btn-success bi-printer-fill w-50" @click="printReceipt()">
                    &nbsp;
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Print</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
    import Vue3Html2pdf from 'vue3-html2pdf'
    const $ = require('jquery');
    export default {
        // eslint-disable-next-line
        name: 'TranferReceipt',
        components: {
            Vue3Html2pdf
        },
        data(){
          return {
            receipt:{
              _id: '',
              items: [],
            },
            options:{
              filename: '',
              margin: 7,
              html2canvas: { 
                scale: 2, 
                letterRendering: false
              },
            }
          }
        },
        created(){
        },
        computed:{
          total(){
            return this.receipt.items.reduce((acc, x)=> acc + x.quantity, 0);
          }
        },
        methods:{
          //**********************************************************
          async view(order_id){
            var ack = await this.$service.getTransferDetails({ id: order_id });
            if(ack.state != 'OK'){
              this.$toast(ack.state);
            }
            else{
              this.receipt = ack.data;
              $('#transferReceiptModal').modal('show');
            }
          },
          //**********************************************************
          async printReceipt(){
            this.$refs.receipt_body.generatePdf();
              // var receiptBody = $('#receipt_body')[0].innerHTML;
              // let scale = 5;
              // let width = 210 * scale, height = 297 * scale;
              // let left = (window.innerWidth - 210) / 2;
              // let top = (window.innerHeight - 297) / 2;
              // const printWindow = window.open('', '', `left=${left},top=${top},width=${width},height=${height},toolbar=0,scrollbars=0,status=0`);
              // let css = Array.from($('link[rel="stylesheet"], style')).reduce((acc, node)=>acc + node.outerHTML, '');
              // printWindow.document.write(`
              //     <head>${css}</head>
              //     <body>${receiptBody}</body>
              // `);
              // printWindow.document.close();
              // printWindow.focus();

              // printWindow.print();
              // await new Promise((res)=>setTimeout(res, 500));
              // printWindow.close();
          }
        }
    }
</script>
<!-- ******************************************************** -->
<style scoped>
#receipt_body > p{
    margin: none !important;
}
table, table tr, table td, table th{
  border-collapse: collapse;
  border: 0.5px solid black;
}
</style>
  